import { EventBus } from '@/util/eventBus';
import { apiAliyunSts } from '../request/api';
import { Decimal } from 'decimal.js'
import OSS from 'ali-oss';

export default {
  // 拷贝
  copyToClipboard(text) {
    var textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = 0;
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  },
  wenhouStr() {
    // 获取当前时间
    const timeNow = new Date();
    // 获取当前小时
    const hours = timeNow.getHours();
    // 设置默认文字
    let text = '';
    // 判断当前时间段
    if (hours >= 0 && hours <= 11) {
      text = 'Good Morning !';
    } else if (hours > 11 && hours <= 13) {
      text = 'Good Afternoon !';
    } else if (hours > 13 && hours <= 18) {
      text = 'Good Afternoon !';
    } else if (hours > 18 && hours <= 24) {
      text = 'Good Evening !';
    }
    // 返回当前时间段对应的状态
    return text;
  },
  // 存储本地数据
  saveTodos(key, todos, times = 0, startTimes = 0) {
    const todosArr = todos;
    try {
      if (todosArr) {
        if (times) {
          todosArr.overTimes = times;
          if (startTimes !== 0) {
            todosArr.startTimes = startTimes;
          } else {
            todosArr.startTimes = Date.parse(new Date());
          }
        }
        // 执行存储
        window.localStorage.setItem(key, JSON.stringify(todosArr));
      } else {
        // 执行删除
        window.localStorage.removeItem(key);
      }
      return true;
    } catch (e) {
      return false;
    }
  },
  // 获取本地数据
  readTodos(key) {
    try {
      let item = window.localStorage.getItem(key);
      item = item !== null ? item : null;
      if(item === null){
        return null;
      }else{
        return JSON.parse(item || '[]');
      }
    } catch (e) {
      return JSON.parse(null);
    }
  },
  // 滚动条距离底部的距离
  scrollToButton(element) {
    // 如果没有指定element，则默认为window
    element = element || window;
    // 获取元素的总高度（对于window，是文档的总高度）
    const totalHeight = element === window
      ? document.body.scrollHeight
      : element.scrollHeight;
    // 获取元素的可视区域高度
    const viewportHeight = document.documentElement.clientHeight;
    // 获取当前滚动条的位置
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 计算滚动条距离底部的距离
    const scrollBottomDistance = totalHeight - viewportHeight - scrollTop;
    return scrollBottomDistance;
  },
  createPostForm(action,formData,method) {
    // 创建一个隐藏的表单
    var form = document.createElement('form');
    form.target = '_blank'; // 如果需要在新标签页中打开，可以设置这个属性（可选）
    form.action = action; // 提交到的URL
    form.method = method; // 使用POST方法
    // 添加表单数据
    var input = null;
    formData.forEach(app=>{
      input = null;
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = app.name;
      input.value = app.value;
      form.appendChild(input);
    });
    // 将表单添加到页面中（虽然是隐藏的，但这个步骤是必须的）
    document.body.appendChild(form);
    // 提交表单
    form.submit();
  },
  // 图片大小
  calculateSizeFun(limit) {
    let size = '';
    if (limit < 0.1 * 1024) { // 小于0.1KB，则转化成B
      size = `${limit.toFixed(2)}B`;
    } else if (limit < 0.1 * 1024 * 1024) { // 小于0.1MB，则转化成KB
      size = `${(limit / 1024).toFixed(2)}KB`;
    } else if (limit < 0.1 * 1024 * 1024 * 1024) { // 小于0.1GB，则转化成MB
      size = `${(limit / (1024 * 1024)).toFixed(2)}MB`;
    } else { // 其他转化成GB
      size = `${(limit / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    }
    const sizeStr = `${size}`; // 转成字符串
    const index = sizeStr.indexOf('.'); // 获取小数点处的索引
    const dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
    if (dou === '00') { // 判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
  },
  makeTupianOneImgShard(vueOb, files, data) {
    console.log(1111);
    const that = this;
    vueOb.is_loading = true;
    // NProgress.start();
    EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
    // 开始
    vueOb.loadingSize = '0B';
    vueOb.loadingProgress = 2;
    vueOb.loadingSize = this.calculateSizeFun(files.size);
    apiAliyunSts({ }).then((ob) => {
      if (ob.state === 1) {
        const ossClient = new OSS({
          // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
          region: ob.data.region,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
          accessKeyId: ob.data.AccessKeyId,
          accessKeySecret: ob.data.AccessKeySecret,
          // 从STS服务获取的安全令牌（SecurityToken）。
          stsToken: ob.data.SecurityToken,
          // 填写Bucket名称，例如examplebucket。
          bucket: ob.data.bucket,
          refreshSTSToken: async () =>
            // 向您搭建的STS服务获取临时访问凭证 - 如果超时
            apiAliyunSts({ }).then(ob => ({ accessKeyId: ob.data.AccessKeyId, accessKeySecret: ob.data.AccessKeySecret, stsToken: ob.data.SecurityToken })).catch((ob) => {
              vueOb.$message.showMsgBox({
                type: 'warning',
                content: '上传失败B-5'
              });
              vueOb.is_loading = false;
              EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            }),
          // 刷新临时访问凭证的时间间隔，单位为毫秒。
          refreshSTSTokenInterval: 5000
        });
        // // 定义文件名
        const fileName = `${that.stringToHex(ob.data.user_md5)}.${that.getFileType(files.name)}`;
        // 服务器回调地址
        const callbackUrl = ob.data.callback;
        // 执行分片上传
        // eslint-disable-next-line no-unused-vars
        const result = ossClient.multipartUpload(fileName, files, {
          progress(p, checkpoint) {
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
            // tempCheckpoint = checkpoint;
            vueOb.loadingProgress = (p * 100).toFixed(0);
            // console.log(checkpoint,'过程过程过程过程过程checkpointcheckpoint');
          },
          meta: { year: 2020, people: 'test' },
          mime: files.type,
          partSize: 131072,
          callback: {
            url: callbackUrl,
            host: '',
            /* eslint no-template-curly-in-string: [0] */
            body: 'filename=${object}&size=${size}&mimeType=${mimeType}&height=${imageInfo.height}&width=${imageInfo.width}&token=${x:token}&type=${x:type}&oldFileName=${x:oldFileName}',
            contentType: 'application/x-www-form-urlencoded',
            customValue: {
              token: data.token, // 唯一识别号ID
              type: data.type, // 文件所属标识
              oldFileName: files.name // 原文件名
            }
          }
        }).then((ob) => {
          if (ob.res.status === 200 && ob.data.state === 200) {
            vueOb.is_loading = false;
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            // 重新加载
            if (data.initFun) {
              data.initFun(ob.data);
            }
            // 取消上传中的状态
            vueOb.$message.showMsgBox({
              type: 'success',
              content: '图片上传成功'
            });
          } else {
            // 如果失败了 那么需要将失败的地址发送至 错误图片 接口
            vueOb.$message.showMsgBox({
              type: 'warning',
              content: '上传失败B-4444'
            });
            vueOb.is_loading = false;
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          }
        }).catch((ob) => {
          console.log(ob, 'xxxxxxxxxx');
          // 如果失败了 那么需要将失败的地址发送至 错误图片 接口
          vueOb.$message.showMsgBox({
            type: 'warning',
            content: '上传失败B-1111'
          });
          vueOb.is_loading = false;
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        });
      } else {
        vueOb.$message.showMsgBox({
          type: 'warning',
          // ob.message
          content: '上传失败B-3333'
        });
        vueOb.is_loading = false;
        EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
      }
    }).catch((ob) => {
      vueOb.$message.showMsgBox({
        type: 'warning',
        content: '上传失败B-2222'
      });
      vueOb.is_loading = false;
      EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
    });
  },
  // 获取十六进制字符串
  stringToHex(str) {
    let strr = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 3; i++) {
      const number = `${Math.ceil(Math.random() * 9)}`;
      strr += number;
    }
    const dateOb = new Date().getTime();
    return `${str}/${(dateOb + strr).split('').reverse().join('')}`;
  },
  // 获取文件后缀名
  getFileType(filePath) {
    const startIndex = filePath.lastIndexOf('.');
    if (startIndex !== -1) {
      return filePath.substring(startIndex + 1, filePath.length).toLowerCase();
    }
    return '';
  },
  isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  },
  // 减法运算
  subtrNumber(arg1, arg2) {
    let a2 = arg1 * 1;
    let b2 = arg2 * 1;
    let c2 = new Decimal(a2).sub(new Decimal(b2));
    return c2.toDecimalPlaces(2,Decimal.ROUND_HALF_UP).toString();
    // return c2.toString();
    // // eslint-disable-next-line one-var
    // let r1,
    //   r2,
    //   m,
    //   n;
    // try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
    // try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
    // // eslint-disable-next-line no-restricted-properties,prefer-const
    // m = Math.pow(10, Math.max(r1, r2));
    // // eslint-disable-next-line prefer-const
    // n = (r1 >= r2) ? r1 : r2;
    // // eslint-disable-next-line no-mixed-operators
    // return ((arg1 * m - arg2 * m) / m).toFixed(n);
  },
  // 乘法
  accMulNumber(arg1, arg2) {
    let a3 = arg1 * 1;
    let b3 = arg2 * 1;
    let c3 = new Decimal(a3).mul(new Decimal(b3));
    return c3.toDecimalPlaces(2,Decimal.ROUND_HALF_UP).toString();
    // return c3.toString();
    // // eslint-disable-next-line one-var
    // let m = 0,
    //   // eslint-disable-next-line prefer-const
    //   s1 = arg1.toString(),
    //   // eslint-disable-next-line prefer-const
    //   s2 = arg2.toString();
    // // eslint-disable-next-line no-empty
    // try { m += s1.split('.')[1].length; } catch (e) {}
    // // eslint-disable-next-line no-empty
    // try { m += s2.split('.')[1].length; } catch (e) {}
    // // eslint-disable-next-line no-mixed-operators,no-restricted-properties
    // return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
  },
  // 除法
  divideNumber(arg1, arg2) {
    let a4 = arg1 * 1;
    let b4 = arg2 * 1;
    let c4 = new Decimal(a4).div(new Decimal(b4));
    return c4.toDecimalPlaces(2,Decimal.ROUND_HALF_UP).toString();
    // return c4.toString();
    // // eslint-disable-next-line one-var
    // let d1,
    //   d2,
    //   // eslint-disable-next-line prefer-const
    //   n1 = Number(arg1.toString().replace('.', '')),
    //   // eslint-disable-next-line prefer-const
    //   n2 = Number(arg2.toString().replace('.', ''));
    // try { d1 = arg1.toString().split('.')[1].length; } catch (e) { d1 = 0; }
    // try { d2 = arg2.toString().split('.')[1].length; } catch (e) { d2 = 0; }
    // // eslint-disable-next-line no-restricted-properties
    // return this.toFixed((n1 / n2) * Math.pow(10, d2 - d1), 2);
  },
  // 加法
  accAddNumber(arg1, arg2) {
    let a1 = arg1 * 1;
    let b1 = arg2 * 1;
    let c1 = new Decimal(a1).add(new Decimal(b1));
    return c1.toDecimalPlaces(2,Decimal.ROUND_HALF_UP).toString();
    // return c1.toString();
    // eslint-disable-next-line one-var
    // let r1,
    //   r2,
    //   m;
    // try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
    // try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
    // // eslint-disable-next-line no-restricted-properties,prefer-const
    // m = Math.pow(10, Math.max(r1, r2));
    // // eslint-disable-next-line no-mixed-operators
    // return (arg1 * m + arg2 * m) / m;
  },
  getData(n) {
    if(n){
      const y = n.getFullYear();
      const m = n.getMonth() + 1;
      const d = n.getDate();
      return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
    }else{
      return '';
    }
  }
};



// WEBPACK FOOTER //
// ./src/util/commons.js